
    import './styles.scoped.css';
    export default {
  "wrapper": "awsui_wrapper_1wepg_u4rug_5",
  "label-wrapper": "awsui_label-wrapper_1wepg_u4rug_12",
  "content": "awsui_content_1wepg_u4rug_17",
  "empty-content": "awsui_empty-content_1wepg_u4rug_23",
  "description": "awsui_description_1wepg_u4rug_27",
  "description-bottom-padding": "awsui_description-bottom-padding_1wepg_u4rug_33",
  "label": "awsui_label_1wepg_u4rug_12",
  "label-disabled": "awsui_label-disabled_1wepg_u4rug_41",
  "description-disabled": "awsui_description-disabled_1wepg_u4rug_42",
  "control": "awsui_control_1wepg_u4rug_47",
  "outline": "awsui_outline_1wepg_u4rug_50"
};
  